// Use like so:
//
// .nested-typed-attrs-group(data-controller="forms--nested-typed-attrs")
//   .nested-typed-attrs-templates(data-forms--nested-typed-attrs-target="templates")
//     %template(data-nested-typed-attribute-type="#{ni_table_attribute_type.id}")
//       .nested-typed-attr-field{ data: { new_record: "true" } }
//         = ns_uic1(:card) do |card|
//           - card.with_body do
//             # Render form item
//           - card.with_footer do
//             = link_to("Remove Attribute",
//                       "#",
//                       data: { action: "click->forms--nested-typed-attrs#remove" })
//   .nested-typed-attrs-fields(data-forms--nested-typed-attrs-target="fields")
//     # Render existing fields
//
//   %hr
//   .nested-typed-attrs-controls
//     .row
//       .col-8
//         = select_tag(:nested_attrs_type,
//                      { class: "form-select w-100",
//                        data: { controller: "forms--select",
//                                "forms--nested-typed-attrs-target": "typeSelect" } })
//       .col-4
//         .d-grid
//           = link_to("+ Add an Attribute",
//                     "#",
//                     class: "btn btn-secondary",
//                     data: { action: "click->forms--nested-typed-attrs#add" })

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['fields', 'templates', 'typeSelect']

  add (event) {
    event.preventDefault()

    const attrType = this.typeSelectTarget.tomselect
      .items
      .find((selectedOption) => typeof selectedOption === 'string' && selectedOption.length > 0)
    const template = this.templatesTarget.querySelector(
      `[data-nested-typed-attribute-type="${attrType}"]`
    )
    const content = template.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime()
    )
    this.fieldsTarget.insertAdjacentHTML('beforeend', content)
  }

  remove (event) {
    event.preventDefault()

    const wrapper = event.target.closest('.nested-typed-attr-field')
    wrapper.remove()
  }
}
